<template>
  <div class="products">
    <header class="products__hero">
      <h1 class="page-title">{{ typeMeta.name }}</h1>
      <!-- <p class="page-desc">
        为开发者提供人工智能相关 API 接口服务。价格与后台「开放平台模型价格」同步（积分）。
      </p> -->
      <div class="products__search">
        <input
          v-model.trim="keyword"
          type="search"
          placeholder="搜索产品名称 / 描述 / 路径"
          aria-label="搜索产品"
        />
      </div>
      <!-- <p v-if="priceError" class="products__price-hint">定价加载失败，暂显示本地默认价：{{ priceError }}</p>
      <p v-else-if="pricingLoaded" class="products__price-hint">价格已同步后台 opengate_models</p> -->
    </header>

    <div class="products__layout">
      <aside class="products__side panel">
        <nav class="products__nav">
          <router-link
            v-for="t in types"
            :key="t.id"
            :to="t.path"
            class="products__nav-item"
            active-class="is-active"
          >
            {{ t.name }}
          </router-link>
        </nav>
      </aside>

      <section class="products__main">
        <p class="products__count mono">共 {{ filtered.length }} 个接口</p>
        <div v-if="!filtered.length" class="products__empty panel">当前分类暂无匹配产品</div>
        <div v-else class="products__grid">
          <article v-for="p in filtered" :key="p.id" class="card panel">
            <div class="card__badges">
              <span class="card__paid" :class="p.paid ? 'is-paid' : 'is-free'">
                {{ p.paid ? '付费' : '免费' }}
              </span>
              <span class="badge" :class="'badge-' + p.method.toLowerCase()">{{ p.method }}</span>
            </div>
            <h2 class="card__title">{{ p.title }}</h2>
            <p class="card__desc">{{ p.desc }}</p>
            <div class="card__meta">
              <span v-if="p.bonus" class="card__bonus">{{ p.bonus }}</span>
              <span>{{ p.limitLabel }}</span>
              <strong>{{ p.priceLabel }}</strong>
            </div>
            <div class="card__path mono">{{ p.path }}</div>
            <router-link class="btn btn-primary card__btn" :to="'/product/' + p.id">
              查看详情
            </router-link>
          </article>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { productTypes, getTypeById, listProductsByType } from '../data/apiCatalog'
import { applyPricingToProduct, loadOpenGatePricing } from '../utils/opengatePricing'

export default {
  name: 'Products',
  data() {
    return {
      types: productTypes,
      keyword: '',
      pricing: null,
      pricingLoaded: false,
      priceError: ''
    }
  },
  computed: {
    typeId() {
      return this.$route.params.typeId || 'all'
    },
    typeMeta() {
      return getTypeById(this.typeId)
    },
    pricedList() {
      return listProductsByType(this.typeId).map(p => applyPricingToProduct(p, this.pricing))
    },
    filtered() {
      const kw = this.keyword.toLowerCase()
      let list = this.pricedList
      if (!kw) return list
      return list.filter(p => {
        const blob = [p.title, p.desc, p.path, p.priceLabel].join(' ').toLowerCase()
        return blob.includes(kw)
      })
    }
  },
  created() {
    this.refreshPricing()
  },
  watch: {
    '$route.params.typeId'() {
      this.keyword = ''
    }
  },
  methods: {
    async refreshPricing() {
      this.priceError = ''
      try {
        this.pricing = await loadOpenGatePricing({ force: true })
        this.pricingLoaded = !!(this.pricing && this.pricing.byModel && Object.keys(this.pricing.byModel).length)
        if (!this.pricingLoaded) {
          this.priceError = '未拿到定价数据'
        }
      } catch (e) {
        this.pricing = null
        this.pricingLoaded = false
        const msg =
          (e && e.response && e.response.data && (e.response.data.message || e.response.data.error)) ||
          (e && e.message) ||
          '网络错误'
        this.priceError = String(msg)
      }
    }
  }
}
</script>

<style scoped>
.products__hero {
  margin-bottom: 8px;
}
.products__price-hint {
  margin: -8px 0 16px;
  font-size: 12px;
  color: #94a3b8;
}
.products__search {
  max-width: 420px;
  margin-bottom: 20px;
}
.products__search input {
  width: 100%;
  border-radius: 999px;
  border: 1px solid var(--line);
  background: rgba(0, 0, 0, 0.28);
  padding: 11px 16px;
  outline: none;
  color: inherit;
}
.products__layout {
  display: grid;
  gap: 16px;
}
@media (min-width: 900px) {
  .products__layout {
    grid-template-columns: 220px 1fr;
    align-items: start;
  }
}
.products__side {
  padding: 10px;
  position: sticky;
  top: 72px;
}
.products__nav {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.products__nav-item {
  display: block;
  padding: 9px 12px;
  border-radius: 8px;
  color: #94a3b8;
  text-decoration: none;
  font-size: 13px;
}
.products__nav-item:hover,
.products__nav-item.is-active {
  background: rgba(52, 211, 153, 0.12);
  color: #e2e8f0;
}
.products__count {
  margin: 0 0 12px;
  font-size: 12px;
  color: #64748b;
}
.products__empty {
  padding: 28px;
  text-align: center;
  color: #94a3b8;
}
.products__grid {
  display: grid;
  gap: 14px;
}
@media (min-width: 720px) {
  .products__grid {
    grid-template-columns: 1fr 1fr;
  }
}
.card {
  padding: 16px 18px 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.card__badges {
  display: flex;
  gap: 8px;
  align-items: center;
}
.card__paid {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
}
.card__paid.is-paid {
  background: rgba(251, 146, 60, 0.2);
  color: #fdba74;
}
.card__paid.is-free {
  background: rgba(56, 189, 248, 0.18);
  color: #7dd3fc;
}
.card__title {
  margin: 0;
  font-size: 17px;
  font-weight: 650;
}
.card__desc {
  margin: 0;
  font-size: 13px;
  color: #94a3b8;
  line-height: 1.5;
  flex: 1;
}
.card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  font-size: 12px;
  color: #94a3b8;
  align-items: baseline;
}
.card__meta strong {
  color: #f8fafc;
  font-weight: 650;
}
.card__bonus {
  color: #34d399;
}
.card__path {
  font-size: 12px;
  color: #64748b;
  word-break: break-all;
}
.card__btn {
  align-self: flex-start;
  margin-top: 4px;
}
</style>
